import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsSplit: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"m8 4l4-4l4 4h-2v4l-4 4v4H6v-4L2 8V4H0l4-4zm0 0H6v2.5l2 2l2-2V4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsSplit
